<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>What's Daily UI?</h1>
          <p>The <a href="https://www.dailyui.co/" target="_blank">Daily UI</a> challenge provides a new design brief every day for 100 days, with prompts to design everything from a landing page to an analytics chart to a crowdfunding website. Here’s a collection of some top picks from my entries thus far.</p>
        </project-text>

        <project-carousel
        size="75"
        :color="$store.state.activeProject.color"
        :autoplay="true">
          <slide><img v-lazy="'/img/p/dailyui/blogpost.jpg'" alt="Blog Post"></slide>
          <slide><img v-lazy="'/img/p/dailyui/crowdfunding.jpg'" alt="Crowdfunding Site"></slide>
          <slide><img v-lazy="'/img/p/dailyui/contact.jpg'" alt="Contact Page"></slide>
          <slide><img v-lazy="'/img/p/dailyui/landing.jpg'" alt="Landing Page"></slide>
        </project-carousel>

        <project-image
        size="50"
        path="/img/p/dailyui/countdown.jpg"
        alt="Countdown Site"/>

        <project-image
        size="50"
        path="/img/p/dailyui/onboarding.jpg"
        alt="App Onboarding"/>

        <project-image
        size="50"
        path="/img/p/dailyui/messaging.jpg"
        alt="Messaging App"/>

        <project-image
        size="50"
        path="/img/p/dailyui/mobile.jpg"
        alt="Render of Movie App Search, Mobile Boarding Pass, and App Settings"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
